export default __webpack_public_path__ + "static/media/photo--sm--wheel-10.f5260262.jpg";